"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function VisaSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id2 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 20, viewBox: "0 0 30 20" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `visa-${id0}`, d: "M.097 2.62C.099 1.303 1.107.235 2.352.23h25.287c1.244.004 2.252 1.072 2.255 2.39v14.96c-.003 1.318-1.011 2.386-2.255 2.39H2.477c-.632-.002-1.238-.27-1.685-.745-.446-.475-.697-1.119-.695-1.79V2.622z" }),
            react_1.default.createElement("path", { id: `visa-${id1}`, d: "M8.863.764L5.904 8.478H3.981L2.527 2.33c-.083-.377-.167-.515-.428-.675C1.649 1.393.928 1.141.29.992L.332.764h3.105c.397 0 .753.286.836.789l.763 4.457L6.95.764h1.913zm7.558 5.2c.01-2.034-2.572-2.149-2.561-3.051.01-.275.25-.572.773-.652.262-.034.983-.068 1.798.343L16.755.97c-.439-.172-1.003-.343-1.704-.343-1.798 0-3.073 1.051-3.084 2.548-.01 1.109.91 1.726 1.6 2.103.71.377.951.617.951.96-.01.515-.564.743-1.087.755-.92.011-1.453-.275-1.871-.492l-.335 1.692c.429.217 1.213.4 2.028.411 1.913 0 3.157-1.04 3.168-2.64zm4.767 2.514h1.683L21.397.764h-1.558c-.345 0-.648.217-.773.56l-2.74 7.143h1.914l.376-1.154h2.342l.23 1.165zm-2.039-2.731l.962-2.892.554 2.892H19.15zM11.466.764L9.96 8.478H8.141L9.647.764h1.819z" }),
            react_1.default.createElement("linearGradient", { id: `visa-${id2}`, x1: "0%", x2: "100%", y1: "49.97%", y2: "49.97%" },
                react_1.default.createElement("stop", { offset: "0%", stopColor: "#1A1E5A" }),
                react_1.default.createElement("stop", { offset: "100%", stopColor: "#122D98" }))),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "visa_prefix_b", fill: "#fff" },
                react_1.default.createElement("use", { xlinkHref: `#visa-${id0}` })),
            react_1.default.createElement("use", { fill: "#FFF", fillRule: "nonzero", xlinkHref: `#visa-${id0}` }),
            react_1.default.createElement("path", { fill: "#F7B600", fillRule: "nonzero", d: "M0.169 16.785L29.802 16.785 29.802 21.892 0.169 21.892z", mask: "url(#visa_prefix_b)" }),
            react_1.default.createElement("path", { fill: "#1A1F71", fillRule: "nonzero", d: "M0.169 -1.692H29.801000000000002V3.4159999999999995H0.169z", mask: "url(#visa_prefix_b)" }),
            react_1.default.createElement("g", { mask: "url(#visa_prefix_b)" },
                react_1.default.createElement("g", { transform: "translate(2.935 5.641)" },
                    react_1.default.createElement("mask", { id: "visa_prefix_e", fill: "#fff" },
                        react_1.default.createElement("use", { xlinkHref: `#visa-${id1}` })),
                    react_1.default.createElement("use", { fill: "url(#visa_prefix__d)", fillRule: "nonzero", xlinkHref: `#visa-${id1}` }),
                    react_1.default.createElement("path", { fill: "#1A1F71", fillRule: "nonzero", d: "M0.452 -1.026L24.215 -1.026 24.215 8.769 0.452 8.769z", mask: "url(#visa_prefix_e)" })))));
}
function Visa(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(VisaSvg, Object.assign({}, svgProps)));
}
exports.default = Visa;
//# sourceMappingURL=Visa.js.map